// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dygraph-xlabel {
	position: relative;
	top: 20px;
}
ul.dashed {
	list-style-type:none;
	margin:0;
	padding-left:10px
}
ul.dashed > li {
	text-indent:-10px;
	margin-top: 5px;
}
ul.dashed > li:before {
	content:"-";
	text-indent:-5px;
	margin-right:5px
}
#homeAndCopyright {
	font-size: 12px;
	position: absolute;
	bottom: 10px;
	right: 10px;
	display: flex;
}
#homeAndCopyright a {
	text-decoration: none;
}
#home, #copyright {
	display: flex;
}
`, "",{"version":3,"sources":["webpack://./main/custom.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,SAAS;AACV;AACA;CACC,oBAAoB;CACpB,QAAQ;CACR;AACD;AACA;CACC,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,WAAW;CACX,gBAAgB;CAChB;AACD;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,aAAa;AACd;AACA;CACC,qBAAqB;AACtB;AACA;CACC,aAAa;AACd","sourcesContent":[".dygraph-xlabel {\n\tposition: relative;\n\ttop: 20px;\n}\nul.dashed {\n\tlist-style-type:none;\n\tmargin:0;\n\tpadding-left:10px\n}\nul.dashed > li {\n\ttext-indent:-10px;\n\tmargin-top: 5px;\n}\nul.dashed > li:before {\n\tcontent:\"-\";\n\ttext-indent:-5px;\n\tmargin-right:5px\n}\n#homeAndCopyright {\n\tfont-size: 12px;\n\tposition: absolute;\n\tbottom: 10px;\n\tright: 10px;\n\tdisplay: flex;\n}\n#homeAndCopyright a {\n\ttext-decoration: none;\n}\n#home, #copyright {\n\tdisplay: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
